module.exports = __webpack_public_path__ + "media/images/icon_btn_message-8b3476bf22adc0729a24609ee74503fd.png";